
import $ from 'jquery';

export function discographySubMenu() {
  $( ".js-openAlbumSubmenu" ).click(function() {
		const elem = $('.js-albumSubmenu');
		elem.css("display", "block");
	});

	$( ".js-closeAlbumSubmenu" ).click(function() {
		const elem = $('.js-albumSubmenu');
		elem.css("display", "none");
	});
  // const mobileDiscographySubMenuToggler  = document.querySelector('.dropdown-toggle');
  // const closeBtn = document.querySelector('.close');

  // mobileDiscographySubMenuToggler.addEventListener('click', (e) => {
  //   e.preventDefault();
  //   const mobileDiscographySubMenu = document.querySelector('.dropdown-menu');
  //   mobileDiscographySubMenu.classList.toggle('album-submenu');
  // });
 
  // closeBtn.addEventListener('click', (e) => {
  //   e.preventDefault();
  //   const mobileDiscographySubMenu = document.querySelector('.dropdown-menu');
  //   mobileDiscographySubMenu.classList.toggle('album-submenu');
  // });

} 

